import config from "../../config";
import { actionTypes } from "./actions";

const initialState = [];

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.DEALER_CONTACT_SET: {
            const { dealerContacts } = action.payload;
            return [...state, ...dealerContacts];
        }
        case actionTypes.DEALER_CONTACT_POST_SUCCESS: {
            const { data } = action.payload;

            // Since data is an array, handle the first item
            const newItem = data[0];

            // Check if item with same id exists in state
            const itemExists = state.some((item) => item.id === newItem.id);

            if (itemExists) {
                return state.map((item) =>
                    item.id === newItem.id ? newItem : item
                );
            } else {
                return [...state, newItem];
            }
        }
        case actionTypes.DEALER_CONTACT_DELETE_SUCCESS: {
            const { id } = action.payload;
            return state.filter((item) => item.id !== id);
        }

        case actionTypes.DEALER_CONTACT_CLEAR: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}
